import _ from 'lodash';
import React, { FunctionComponent, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';

/*
Phil description:
The default screen print email feature was added by Gail on 5-11-18.  In ATC13, on page 1 for parts invoices
and page 2 for ROs, there is a space to enter a default e-mail address. For each, there is a field for the default
e-mail address and a flag that keeps that address as the default. If an invoice goes on credit hold and the hold
is sent to the credit department, and a default address is on file, and the counterman has the ABILITY to print
invoices to the screen printer (it does not matter which printer they picked to send the invoice to), then the
program displays the default address. The counterman can accept the default or enter a new address. If they do
not enter a new address then the default is used. If they do enter an address and the flag to keep the original
address as the default is set to no, then the current address is stored as the default for the next time.

TODO: Default screen print is passthrough as of 6/4/19.  Ability to change not yet added as we aren't sure if
this is even used by anyone or not, and it might confuse people to show it unless needed.  We'll see.

IBS / SPLIT support: Per Kevin, Fleet Billed customers are set to use unlimited credit anyways.
                     Per Tom, IBS SPLIT support is 20+ years old and not used to his knowledge.
*/

interface IProps {
  container: Object;
  defaultScreenPrintEmail: string;
  hide: () => void;
  holdNumber: string;
  onPostOpProcess: (creditHoldPostOpFields: { action: string; holdNumber: string; screenPrintEmail: string }) => void;
  onPrintPickTicket: () => void;
  postOpActions: string[];
  show: boolean;
}

const CreditHoldPostOpModal: FunctionComponent<IProps> = ({
  container,
  defaultScreenPrintEmail,
  hide,
  holdNumber,
  onPostOpProcess,
  onPrintPickTicket,
  postOpActions,
  show,
}) => {
  const [selectedAction, setSelectionAction] = useState('');

  return (
    <Modal
      backdrop="static"
      container={container as any}
      dialogClassName="sk-creditHoldPostOpModal"
      onHide={hide as any}
      show={show}
    >
      <Modal.Header>
        <Modal.Title>
          <div className="sk-creditHoldTitle">
            <div>Credit Hold Detected</div>
            <div>
              <span className="sk-creditHoldPrintPickTicket" onClick={onPrintPickTicket} title="Print Pick Ticket">
                <i className="fas fa-print" /> Pick Ticket
              </span>
            </div>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="sk-creditHoldSelectAction">Select action for hold #{holdNumber}:</div>
        {postOpActions.map((action, index) => (
          <div
            className={`sk-creditHoldActionItem${action === selectedAction ? ' sk-creditHoldActionItemActive' : ''}`}
            key={`sk-cha-${index}`}
            onClick={() => setSelectionAction(action)}
          >
            {action}
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="success"
          disabled={selectedAction === ''}
          onClick={() => {
            onPostOpProcess({
              action: selectedAction,
              holdNumber,
              screenPrintEmail: defaultScreenPrintEmail,
            });
          }}
        >
          Process
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreditHoldPostOpModal;
